module.exports = __webpack_public_path__ + "img/3.200d7884.jpg";